webpackJsonp([134928267902561],{

/***/ 426:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Write Code Everyday","subtitle":"I'm interested in React, GraphQL.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Steve Han","email":"heeinso@snu.ac.kr","github":"/heeinso","rss":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/first-posting/","categorySlug":"/categories/gatsby/"},"frontmatter":{"title":"첫 포스팅","date":"2018-02-13T12:30:00.962Z","category":"Gatsby","description":"글또를 시작하는 다짐"}}}]}},"pathContext":{"tag":"Gatsby"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-gatsby-eb896876fe7047674a25.js